<template>
  <div>
    <table>
      <thead>
        <tr>
          <th v-for="(key,indexOf) in columns" :key="indexOf" @click="sortBy(key)" :class="{ active: sortKey == key && isSortKey(key), pointer: isSortKey(key)}">
            {{ key | prettifyCamelCase}}
            <span class="arrow" :class="(sortOrders[key] > 0 || sortOrders[key] === undefined) ? 'asc' : 'dsc'" v-if="isSortKey(key)"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry,indexOf) in filteredData" :key="indexOf">
          <td v-for="key in columns" v-bind:value="key" :key="entry[key]">
            <button tabindex="-1" class="btn btn-primary" @click="setJobId(entry)" v-if="key === 'Access Report'">View Report</button>
            <div class="model-name" v-else-if="key === 'Name'">
              <span>{{entry[key]}}</span>
              <button :disabled="viewButton" tabindex="-1" class="btn btn-secondary view-btn" @click="openSetting(entry, $event)" type="button">
                <svg width="20" height="20" viewBox="0 -3 35 35" fill="#ffffff">
                  <g transform="scale(0.03125 0.03125)">
                    <path d="M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z"></path>
                  </g>
                </svg>
              </button>
              <!-- @click="$emit('showModel', 'view', entry['Access Report'])" -->
              <!-- @click="$emit('openSetting', 'view', entry['Access Report'])" -->

            </div>
            <span v-else>{{entry[key]}}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="settingPopup" ref="settingPopup" v-bind:style="{top: '10px', right: '10px'}">
      <a class="closebtn" @click="settingPopupClose">
        <i aria-hidden="true" class="fa fa-times"></i>
      </a>
      <button class="btnDelete" @click="removeSelectedJobAlert(currententPointData, $event)">
        <i class="fa fa-trash"></i>
      </button>
      <button class="btnViewModel" @click="$emit('showModel', 'view', currentJobView), settingPopupClose()">
        <i class="fa fa-eye"></i>
      </button>
    </div>
    <nav v-if="shouldShowPagination">
      <div class="ui centered pagination menu">
        <button class="icon item" :class="{ disabled: pagination.currentPage === 1 }" @click="pageClicked( pagination.currentPage - 1 )">Prev
          <i class="left chevron icon"></i>
        </button>
        <button class="item" :class="{ active: isActive(page), disabled: page === '...' }" v-for="page in pageLinks" @click="pageClicked(page)" v-bind:key="page">
          {{ page }}
        </button>
        <button class="icon item" :class="{ disabled: pagination.currentPage === this.pagination.totalPages }" @click="pageClicked( pagination.currentPage + 1 )">Next
          <i class="right chevron icon"></i>
        </button>
      </div>
    </nav>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import Jquery from 'jquery'
var $ = Jquery
import Simplert from 'vue2-simplert'
export default {
  name: 'DemoGrid',
  components: { Simplert },
  props: {
    data: Array,
    columns: Array,
    filterKey: String,
    pagination: {
      type: Object,
      default: () => ({})
    },
    sortKeys: Array
  },
  data: function () {
    var sortOrders = {}
    this.columns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders,
      settingPopupStyle: {},
      currentJobView: '',
      currententPointData: [],
      viewButton: false
    }
  },
  computed: {
    filteredData: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        if (this.isSortKey(sortKey)) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
      }
      return data.filter((row, indexOf) => {
        let start = (this.pagination.currentPage - 1) * this.pagination.dataPage
        let end = this.pagination.currentPage * this.pagination.dataPage
        if (indexOf >= start && indexOf < end) {
          return true
        }
      })
    },
    pageLinks () {
      if (this.pagination.totalPages === undefined) {
        return []
      }
      const arr = []
      let preDots = false
      let postDots = false
      for (let i = 1; i <= this.pagination.totalPages; i++) {
        if (this.pagination.totalPages <= 10) {
          arr.push(i)
        } else {
          if (i === 1) {
            arr.push(i)
          } else if (i === this.pagination.totalPages) {
            arr.push(i)
          } else if (
            // link is within 4 of current
            (i > this.pagination.currentPage - 4 && i < this.pagination.currentPage + 4) ||
            // current and link less than 4
            (i < 4 && this.pagination.currentPage < 4) ||
            // current and link within 4 of end
            (i > this.pagination.totalPages - 4 && this.pagination.currentPage > this.pagination.totalPages - 4)) {
            arr.push(i)
          } else if (i < this.pagination.currentPage && !preDots) {
            arr.push('...')
            preDots = true
          } else if (i > this.pagination.currentPage && !postDots) {
            arr.push('...')
            postDots = true
          }
        }
      }
      return arr
    },
    shouldShowPagination () {
      if (this.pagination.totalPages === undefined) {
        return false
      }
      if (this.pagination.count === 0) {
        return false
      }
      return this.pagination.totalPages > 1
    }
  },
  filters: {
    capitalize: function (str) {
      str = str.charAt(0).toUpperCase() + str.slice(1)
      return str
    },
    prettifyCamelCase: function (str) {
      var output = ''
      var len = str.length
      var char
      for (var i = 0; i < len; i++) {
        char = str.charAt(i)
        if (i === 0) {
          output += char.toUpperCase()
        } else if (char !== char.toLowerCase() && char === char.toUpperCase()) {
          output += ' ' + char
        } else if (char === '-' || char === '_') {
          output += ' '
        } else {
          output += char
        }
      }
      return output
    }
  },
  methods: {
    errorPopup () {
      let err = {
        title: 'Data Error',
        message: ' ',
        type: 'error',
        customClass: 'error'
      }
      this.$refs.simplert.openSimplert(err)
    },
    settingPopupClose () {
      // this.$refs.settingPopup.style.display = 'none'
      this.currentJobView = ''
      this.$refs.settingPopup.classList.remove('active')
      this.currententPointData = []
      $('.model-history .highlitetr').removeClass('highlitetr')
      this.viewButton = false
    },
    openSetting (entPointData, objevent) {
      let clientattrib = objevent.currentTarget.getClientRects()
      let xPos = (clientattrib[0].left - 40)
      let yPos = (clientattrib[0].top - 10)
      console.log(entPointData)
      console.log(objevent, xPos, yPos)
      this.currentJobView = entPointData['Access Report']
      this.currententPointData = entPointData
      // let stylepo = [{'top': xPos, 'right': yPos, 'display': 'block'}]
      this.$refs.settingPopup.style.left = xPos + 'px'
      this.$refs.settingPopup.style.top = yPos + 'px'
      this.$refs.settingPopup.classList.add('active')
      $('.model-history .highlitetr').removeClass('highlitetr')
      this.viewButton = true
      objevent.currentTarget.parentNode.parentNode.parentElement.classList.add('highlitetr')
      // this.$refs.settingPopup.style.display = 'block'
      // stylepo = JSON.stringify(stylepo)
      // this.settingPopupStyle = JSON.parse(stylepo)
      // console.log(this.settingPopupStyle)
      // this.$refs.settingPopup.style.top = xPos
      // this.$refs.settingPopup.style.right = yPos
    },
    removeSelectedJobAlert (entPointData, objevent) {
      let entPointDatain = entPointData
      let objeventin = objevent
      let self = this
      let confirmCloseModal = {
        title: 'Are you sure you want to delete Model?',
        type: 'info',
        useConfirmBtn: true,
        customConfirmBtnText: 'Yes',
        customCloseBtnText: 'No',
        customConfirmBtnClass: 'btn btn-primary',
        customCloseBtnClass: 'btn btn-primary',
        onConfirm: function () {
          self.removeSelectedJob(entPointDatain, objeventin)
        }
      }
      this.$refs.simplert.openSimplert(confirmCloseModal)
    },
    removeSelectedJob (entPointData, objevent) {
      var jobtodel = entPointData['Access Report']
      var self = this
      jobtodel = jobtodel.replace('job-id=', '')
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/velocitydeletemodel',
        data: { 'user-id': window.localStorage.getItem('user'), 'job-id': jobtodel },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.loadingtext = 'processing...'
          $('.spinner').show()
        },
        complete: function () {
          self.settingPopupClose()
          self.viewButton = false
          $('.spinner').hide()
          // window.location.reload()
        },
        success: function (data) {
          console.log(data)
          window.location.reload()
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          $('.spinner').hide()
          self.errorPopup()
        }
      })
    },
    sortBy: function (key) {
      if (this.sortOrders[key] === undefined) {
        var orders = {}
        this.columns.forEach(function (key) {
          orders[key] = 1
        })
        this.sortOrders = orders
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
      } else {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
      }
    },
    setJobId: function (jobId) {
      let jId = jobId['Access Report']
      let ver = jobId.version_id
      window.localStorage.setItem('JobId', jId)
      window.localStorage.setItem('JobVersion', ver)
      this.$router.push('/report')
    },
    isActive (page) {
      const currentPage = this.pagination.currentPage || 1
      return currentPage === page
    },
    pageClicked (page) {
      if (page === '...' || page === this.pagination.currentPage || page > this.pagination.totalPages || page < 1) {
        return
      }
      this.$emit('pageChange', page)
    },
    getData: function () {
      var sortOrders = {}
      this.columns.forEach(function (key) {
        sortOrders[key] = 1
      })
      return {
        sortOrders: sortOrders
      }
    },
    isSortKey: function (key) {
      var length = this.sortKeys.length
      for (var i = 0; i < length; i++) {
        if (this.sortKeys[i] === key) return true
      }
      return false
    }
  }
}

</script>
<style lang="css" scoped>
.settingPopup {
  position: absolute;
  width: 0px;
  top: -11px;
  right: -10px;
  border: 1px solid #232323;
  padding: 10px;
  background: RGBA(0, 0, 0, 0.6);
  transition: all 0.5s linear;
  height: 0px;
  z-index: 99;
  display: none;
}
.settingPopup.active {
  height: 60px;
  width: 110px;
  display: block;
  transition: all 0.2s linear;
}
.model-name {
  position: relative;
}
.closebtn {
  font-weight: 700;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  position: absolute;
  top: -10px;
  right: -10px;
  display: inline-block;
  background: #fff;
  border-radius: 100px;
  padding: 0 5px;
  font-size: 15px;
  line-height: 21px;
  cursor: pointer;
}
.btnDelete {
  font-size: 25px;
  color: #000;
  display: inline-block;
  line-height: 36px;
  padding: 0 10px;
  background: #fff;
  border-radius: 3px;
}

.btnViewModel {
  font-size: 23px;
  color: #000;
  display: inline-block;
  line-height: 36px;
  padding: 0 7px;
  background: #fff;
  border-radius: 3px;
  margin-left: 5px;
}
tr.highlitetr td {
  background-color: #f19e28;
}
</style>




// WEBPACK FOOTER //
// DemoGrid.vue?22b22e4a